import React from 'react';
interface OrderBumpProps {
  isBumpSelected: boolean;
  setIsBumpSelected: (val: boolean) => void;
}
export function OrderBump({
  isBumpSelected,
  setIsBumpSelected
}: OrderBumpProps) {
  return <div className="max-w-3xl mx-auto mt-8 mb-6 px-4" data-id="element-98">
      {/* Outer wrapper: Soft Cream bg + Gold Dashed Border + Outer Glow */}
      <div className="rounded-[20px] p-1" style={{
      backgroundColor: '#FFFDFA',
      border: '2px dashed #D4AF37',
      boxShadow: '0 4px 24px rgba(212, 175, 55, 0.25), 0 2px 8px rgba(0,0,0,0.08)'
    }} data-id="element-99">
        <div className={`relative rounded-[18px] p-6 pt-10 transition-all duration-300 cursor-pointer ${isBumpSelected ? 'ring-2 ring-brand-teal ring-offset-2' : ''}`} style={{
        backgroundColor: '#FFFDFA'
      }} onClick={() => setIsBumpSelected(!isBumpSelected)} data-id="element-100">
          {/* Floating Red Urgency Banner */}
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap z-10" data-id="element-101">
            <div className="px-4 py-2 rounded-full text-white font-bold text-xs sm:text-sm tracking-wide shadow-lg" style={{
            backgroundColor: '#DC2626'
          }} data-id="element-102">
              SOLO HOY: -85% DE DESCUENTO ADICIONAL (AHORRE $22)
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-start gap-6 mt-2" data-id="element-103">
            {/* Image on the left */}
            <div className="flex-shrink-0 w-full md:w-32" data-id="element-104">
              <img src="https://cdn.magicpatterns.com/uploads/api8pp2fYzuYrxpaGXSkFH/nuevobump.png" alt="El Código del Silencio" className="w-full h-auto rounded-[12px] shadow-md" data-id="element-105" />
            </div>

            <div className="flex-grow" data-id="element-106">
              <p className="mb-2 text-base sm:text-lg" style={{
              color: '#0F3C3C',
              fontWeight: 600
            }} data-id="element-107">
                Evite destrozos y quejas de vecinos cuando usted sale de casa.
              </p>

              <p className="text-gray-600 text-sm mb-4" data-id="element-108">
                Añada{' '}
                <span className="font-bold text-gray-800" data-id="element-109">
                  EL CÓDIGO DEL SILENCIO
                </span>{' '}
                por solo{' '}
                <span className="text-base" style={{
                color: '#991B1B',
                fontWeight: 700
              }} data-id="element-110">
                  $4.90 USD
                </span>{' '}
                <span style={{
                color: '#991B1B',
                fontWeight: 700
              }} data-id="element-111">
                  (-85% OFF)
                </span>
              </p>

              {/* iOS-Style Toggle Switch — PRESERVED EXACTLY */}
              <div className="flex items-center gap-3" data-id="element-112">
                <div className={`relative w-14 h-8 rounded-full transition-colors duration-300 ${isBumpSelected ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-113">
                  <div className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-md transition-transform duration-300 ${isBumpSelected ? 'translate-x-6' : 'translate-x-0'}`} data-id="element-114"></div>
                </div>
                <span className="text-sm font-semibold text-gray-700" data-id="element-115">
                  {isBumpSelected ? 'Añadido al pack' : 'Añadir al pack'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}